


















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import WarehouseResortForm from '../WarehouseResortForm/WarehouseResortForm.vue'
import WarehouseResortMultipleForm from '../WarehouseResortMultipleForm/WarehouseResortMultipleForm.vue'

import TitleBar from '@/components/Elements/TitleBar.vue'
import moment from 'moment'
import XLSX from "xlsx";

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta', 'days',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WarehouseResortList extends Vue {
  public warehouse_id: any = null;
  public targetDates: any[] = [];
  public actor!: any;

  get titleStack () {
    return [
      'Перегруппировка'
    ]
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  clearDateTime() {
    console.log(this.targetDates)
    this.targetDates = []
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: null,
        until: null,
      }
    })
  }

  onPageChange(page: string) {
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  onSortChange(field: string, order: string) {
    console.log(field, order)
    this.$router.replace({
      query: { ...this.$route.query, sortField: field, sortDirection: order }
    })
  }

  uploadFile(file: File, type: string) {
    const formData = new FormData();

    formData.append('file', file);

    // @ts-ignore
    this.$http.post(`/api/v1/parse_remains`,
      formData, {}
    ).then((response: any) => {
      console.log('response', response)
      this.WarehouseResortMultipleForm(response.data.result, '')
    })
  }

  onWarehouseChange(warehouse_id: string) {
    console.log('onWarehouseChange', warehouse_id)
    this.$router.replace({
      query: { ...this.$route.query, warehouse_id }
    })
  }

  openWarehousesResortForm(row: any) {
    const manager_id = this.actor.document.id
    this.$buefy.modal.open({
      component: WarehouseResortForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {
          warehouse_id: row.warehouse_id,
          manager_id
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  WarehouseResortMultipleForm(rows: any[], group_key: string) {
    this.$buefy.modal.open({
      component: WarehouseResortMultipleForm,
      props: {
        group_key,
        initParams: {
          rows
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  tableToExcel() {
    console.log('tableToExcel')
    this.$store.dispatch(`${STORE_KEY}/exportData`).then((csvContent: any[]) => {
      const ws = XLSX.utils.aoa_to_sheet(csvContent);
      // @ts-ignore
      const range = XLSX.utils.decode_range(ws['!ref']);
      for(let R = range.s.r; R <= range.e.r; ++R) {
        for(let C = range.s.c; C <= range.e.c; ++C) {
          const cellref: string = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
          if(ws[cellref] && C == 6 && R >= 1) {
            const cell = ws[cellref];
            cell.t = 'n'
            cell.z = '0.00'
          }
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Отчет");
      XLSX.writeFile(wb, 'export.xlsx')
    }).catch((error: any) => {
      console.error(error);
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query.since) {
      this.targetDates = [
        // @ts-ignore
        moment(this.$route.query.since).toDate(),
        // @ts-ignore
        moment(this.$route.query.until).toDate(),
      ]
    }else {
      this.targetDates = []
    }
    if (this.$route.query.warehouse_id) {
      this.warehouse_id = this.$route.query.warehouse_id
    }
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
